import React from "react";
import { Outlet, Navigate } from 'react-router-dom';
import { connect } from "react-redux";

function useAuth(logvalue) {
    // let logdata = logvalue;
    // if (localStorage.getItem('token') === 'true') {
    //     logdata = true;
    // }
    const user = { login: logvalue }
    return (
        user && user.login
    )
}

const ProtectedRouters = (props) => {
    let isLoggedCheck = props.isLogged;

    const isAuth = useAuth(isLoggedCheck);
    return isAuth ? <Outlet /> : <Navigate to="/login" />;
}

const mapStateToProps = (state) => {
    return {
        isLogged: state.rootReducer.authReducer.isLoggedIn
    }
}
export default connect(mapStateToProps, null)(ProtectedRouters);